import { Moon, Sun, SunMoon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useTheme } from '@/components/theme-provider';
import { cn } from '@/utils/utils';

export type ModeToggleProps = {
  className?: string;
};

export const ModeToggle: React.FC<ModeToggleProps> = ({ className }) => {
  const { theme, setTheme } = useTheme();

  return (
    <Button
      variant="outline"
      size="icon"
      className={className}
      onClick={() =>
        setTheme(
          theme === 'light' ? 'dark' : theme === 'dark' ? 'system' : 'light'
        )
      }
    >
      <Sun
        className={cn(
          'h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all',
          { '-rotate-90 scale-0': theme !== 'light' }
        )}
      />
      <Moon
        className={cn(
          'absolute h-[1.2rem] w-[1.2rem] transition-all rotate-0 scale-100',
          { 'rotate-90 scale-0': theme !== 'dark' }
        )}
      />
      <SunMoon
        className={cn(
          'absolute h-[1.2rem] w-[1.2rem] transition-all rotate-0 scale-100',
          { 'rotate-180 scale-0': theme !== 'system' }
        )}
      />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
};
